import type { Venue } from "@/api/vendure/merchant/merchant.types";
import type { WebAppManifest, WebAppManifestIcon } from "@/lib/manifest.types";

export const DEFAULT_MANIFEST_ICONS: WebAppManifestIcon[] = [
  { src: "/icon-192.png", sizes: "192x192", type: "image/png" },
  { src: "/icon-512.png", sizes: "512x512", type: "image/png" },
];

export function venueManifestPath(slug: string): string {
  return `/business/${encodeURIComponent(slug)}/manifest.webmanifest`;
}

// iOS "Add to Home Screen" launches the manifest's start_url, so each venue needs its own
// manifest or the icon opens the site root instead of the restaurant.
export function buildVenueManifest(
  venue: Pick<Venue, "name" | "image_url">,
  slug: string,
): WebAppManifest {
  const path = `/business/${encodeURIComponent(slug)}`;
  return {
    id: path,
    name: venue.name,
    short_name: venue.name,
    start_url: path,
    scope: "/",
    display: "standalone",
    theme_color: "#000000",
    background_color: "#ffffff",
    icons: venue.image_url
      ? [{ src: venue.image_url }]
      : DEFAULT_MANIFEST_ICONS,
  };
}
